export function rnd(): number
/**
 * @param max returns integer between 0 and max
 */
export function rnd(max: number): number
/**
 * @returns returns integer between min and max
 */
export function rnd(min: number, max: number): number
export function rnd(maxOrMin?: number, max?: number) {
  const random = Math.random
  if (maxOrMin === undefined) return random()
  if (max === undefined) return Math.floor(random() * maxOrMin)
  if (maxOrMin > max) throw new Error('max cannot be less than min in rnd')
  return Math.round(random() * (maxOrMin - max) + max)
}

export const pickRandom = <T>(arr: readonly T[]): T => arr[Math.floor(rnd() * arr.length)] as T

const MAX_INT32 = 2 ** 31 - 1
export const randomIntegerString = () => Math.floor(Math.random() * (MAX_INT32 + 1)).toString()
